import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layers } from "lucide-react";
import { api } from "../api";
import { EmulationFlag } from "../components/emulation/EmulationFlag";
import { EMULATOR } from "../constants/testIds";

const PERSONA_LABELS = {
  super_admin: "Super Admin", front_of_house_mgr: "Manager", front_of_house_fd: "Front Desk",
  trainer: "Trainer", member: "Member", guest: "Guest",
};

// UX-CP-03 §1/§5.11 — the honest "screens not yet available for this persona" state (Member/
// Guest have no authentication-account/app-surface concept in SCHEMA.md at all yet). A
// top-level route (not nested in the staff `/app/*` shell, which would wrongly show a staff
// sidebar for a non-staff persona) — self-contained: fetches its own `/me` since it isn't
// wrapped by AppDataProvider.
export default function EmulateUnavailable() {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/me")
      .then((res) => setMe(res.data))
      .catch(() => navigate("/kairoo/login"))
      .finally(() => setLoading(false));
  }, [navigate]);

  if (loading) return null;
  if (!me?.emulation?.active) {
    navigate("/kairoo/dashboard");
    return null;
  }

  return (
    <div className="scarlet-canvas min-h-screen flex items-center justify-center" style={{ paddingTop: "var(--emulation-flag-height)" }} data-testid={EMULATOR.unavailablePage}>
      <EmulationFlag emulation={me.emulation} orgId={me.organization_id} gymName={me.organization_display_name} />
      <div className="solid-surface rounded-[14px] p-16 flex flex-col items-center text-center max-w-lg">
        <Layers size={28} style={{ color: "var(--scarlet-text-secondary)" }} className="mb-3" />
        <p className="font-semibold" style={{ color: "var(--scarlet-text)" }}>
          {PERSONA_LABELS[me.emulation.persona] || me.emulation.persona} screens aren't built yet
        </p>
        <p className="text-sm mt-1" style={{ color: "var(--scarlet-text-secondary)" }}>
          There's no app surface for this persona in FitFrikArena yet — this is an honest
          placeholder, not a fabricated screen. Use the flag above to end this session or
          escalate to the relevant Control-Plane screen.
        </p>
      </div>
    </div>
  );
}
